const ProgramacaoActionTypes = {
    PROGRAMACAO: "evento/programacao",
}

export default ProgramacaoActionTypes;